import script from "./KnowledgeFloatPanel.vue?vue&type=script&setup=true&lang=js"
export * from "./KnowledgeFloatPanel.vue?vue&type=script&setup=true&lang=js"

import "./KnowledgeFloatPanel.vue?vue&type=style&index=0&id=06db9e0e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-06db9e0e"]])

export default __exports__